import { getMonthlyRepaymentAmount } from './getMonthlyRepaymentAmount';
import { TDrawdownRepaymentSchedule } from './repaymentSchedule.types';

export const getMinMonthlyRepaymentAmount = (
    repaymentSchedule: TDrawdownRepaymentSchedule
): number | null => {
    if (repaymentSchedule.summary.is_equal_repayment) {
        return getMonthlyRepaymentAmount(repaymentSchedule);
    }

    const firstPrincipalPayment = repaymentSchedule.schedule.find(
        (item) => item.principal > 0
    );

    return firstPrincipalPayment?.total ?? null;
};
